import {Field,ErrorMessage} from 'formik'
const FormSelect =({name,label,id,options})=>{
    return (<>
            <label>{label}</label>
             <Field as="select" id={id}  name={name}  className='form-select'>
                 {options.map(option=>(
                     <option key={option.value} value={option.value}>{option.label}</option>
                 ))}
             </Field>
            <ErrorMessage name={name} component='div' className='text-danger'/>
        </>
    )
}

export default FormSelect